import { Subject } from 'rxjs';
import { ServiceBusClient } from './service-bus-client';
import { ServiceBusServer } from './service-bus-server';
/**
 * 服务总线
 *
 */
export class ServiceBusImp {
    constructor() {
        this._servers = [];
        this._serverRegistered = new Subject();
    }
    get serverRegistered() {
        return this._serverRegistered;
    }
    getClient(serverAppName) {
        return new ServiceBusClient(serverAppName, this);
    }
    addServer(appName) {
        const server = new ServiceBusServer(appName, this);
        this.registerServer(server);
        return server;
    }
    getServer(appName) {
        const server = this._servers.find((s) => s.appName === appName);
        return server;
    }
    registerServer(server) {
        if (!server) {
            throw new Error('register serviceBusServer cannot be null');
        }
        const index = this._servers.findIndex((s) => s.appName === server.appName);
        if (index > -1) {
            this._servers[index] = server;
        }
        else {
            this._servers.push(server);
        }
        this._serverRegistered.next(server);
    }
    removeServer(appName) {
        this._servers = this._servers.filter((s) => s.appName !== appName);
    }
}
